import React, { Component, Fragment } from 'react'
import moment from 'moment'
import isISO8601 from 'validator/lib/isISO8601'
import { withUser } from '../HOC'
import {
  Grid,
  Dimmer,
  Loader,
  Image,
  Icon,
  Dropdown,
  Divider,
  Form,
  Message
} from 'semantic-ui-react'
import PropTypes from 'prop-types'
import db from '../../helpers/db'

class GameForm extends Component {
  state = {
    loading: true,
    teams: [],
    errors: {},
    form: {
      away: null,
      search: '',
      datetime: ''
    }
  }

  static propTypes = {
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired
  }

  componentDidMount = () => {
    if (this.props.user.team)
      return db.teams.find({}, this.formatTeam).then(teams =>
        this.setState(
          {
            teams: teams.filter(team => team.key !== this.props.user.team.id),
            loading: false
          },
          async () => {
            const {
              match: {
                params: { id }
              }
            } = this.props
            if (id) {
              const game = await db.games.findById(id)
              const awayTeam = teams.find(team => team.key === game.teams[1].id)
                .value
              this.setState({
                form: {
                  away: awayTeam,
                  search: awayTeam.name,
                  datetime: moment(game.timeStamp.toDate()).format(
                    'YYYY-MM-DDTkk:mm'
                  )
                }
              })
            }
          }
        )
      )
    else this.props.history.push('/admin/games')
  }

  async formatTeam(doc) {
    return {
      key: doc.id,
      text: doc.name,
      value: { id: doc.id, ...doc },
      image: { avatar: true, src: doc.logo }
    }
  }

  setErrors = () => {
    const { datetime, away } = this.state.form
    return {
      datetime: !isISO8601(datetime),
      away: !away
    }
  }

  onChange = (_, { name, value }) => {
    this.setState(({ form }) => ({ form: { ...form, [name]: value } }))
  }

  onSubmit = () => {
    const {
      match: {
        params: { id }
      }
    } = this.props
    this.setState({ loading: true, errors: this.setErrors() }, () => {
      if (
        Object.keys(this.state.errors).filter(key => this.state.errors[key])
          .length
      )
        return this.setState({ loading: false })
      return (id
        ? db.games.update(id, {
            timeStamp: new Date(this.state.form.datetime),
            teams: [
              db.teams.ref(this.props.user.team.id),
              db.teams.ref(this.state.form.away.id)
            ]
          })
        : db.games.create({
            owner: db.users.ref(this.props.user.uid),
            active: false,
            timeStamp: new Date(this.state.form.datetime),
            state: {
              adIndex: 0,
              error: '',
              boardEnabled: true,
              keyPlay: false,
              down: 1,
              quarter: 1,
              yardsLeft: 10,
              possession: 1,
              scoring: false,
              scores: [0, 0],
              play: {
                data: [0, 1],
                text: 'Pass Middle'
              }
            },
            teams: [
              db.teams.ref(this.props.user.team.id),
              db.teams.ref(this.state.form.away.id)
            ]
          })
      )
        .catch(({ message }) => {
          this.setState(state => ({
            errors: { ...state.errors, generic: message }
          }))
        })
        .then(() => this.props.history.push('/admin/games'))
    })
  }

  render() {
    const { errors, loading } = this.state
    if (loading)
      return (
        <Dimmer active>
          <Loader />
        </Dimmer>
      )
    const { away } = this.state.form
    const {
      match: { params }
    } = this.props
    return (
      <Form
        error={Boolean(Object.keys(errors).filter(key => errors[key]).length)}
        onSubmit={this.onSubmit}
        loading={this.state.loading}
      >
        <h1>{params.id ? 'Edit Game' : 'New Game'}</h1>
        <Divider />
        <Message error content={this.state.errors.generic} />
        <Form.Input
          onChange={this.onChange}
          type="datetime-local"
          value={this.state.form.datetime}
          name="datetime"
          icon="calendar"
          iconPosition="left"
          label="Date"
        />
        {errors.datetime && (
          <Message error content={'Date must not be empty'} />
        )}
        <Form.Field label="Away Team" />
        <Dropdown
          onSearchChange={(_, { searchQuery: value }) => {
            this.onChange(null, { name: 'search', value })
          }}
          searchQuery={this.state.form.search}
          fluid
          search
          selection
          placeholder="Away Team"
          noResultsMessage="No results."
          name="away"
          style={{ marginBottom: 10 }}
          onChange={this.onChange}
          options={this.state.teams}
        />
        {errors.away && <Message error content={'Select an away team'} />}
        <Grid relaxed padded centered>
          <Grid.Row columns="equal" textAlign="center" verticalAlign="middle">
            <Grid.Column textAlign="center">
              <Image size="huge" src={this.props.user.team.logo} />
              <h3>{this.props.user.team.name}</h3>
            </Grid.Column>
            <Grid.Column verticalAlign="middle" textAlign="center">
              <h1>vs.</h1>
            </Grid.Column>
            <Grid.Column verticalAlign="middle" textAlign="center">
              {away ? (
                <Fragment>
                  <Image size="huge" src={away.logo} />
                  <h3>{away.name}</h3>
                </Fragment>
              ) : (
                <Fragment>
                  <Icon size="huge" name="question" />
                  <h3>Select an away team</h3>
                </Fragment>
              )}
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Form.Button fluid size="big" content="Save" color="green" />
      </Form>
    )
  }
}

export default withUser(GameForm)



// WEBPACK FOOTER //
// ./src/components/Admin/GameForm.jsx